/**
 * User & Store Context CrossFrame Listeners
 *
 * Handles CrossFrame requests for user and store context operations.
 * Delegates to the internal userAndStoreContext API for context/alias/store-info,
 * and to the StoreManagementClientFactory gateway client for getUserStores.
 */

import { getUserAndStoreContext, getUserAlias, getStoreInformation, getUserMerchants, IUserAndStoreContext, GetStoreApiOutput, IGetUserMerchantsResult } from '@api/userAndStoreContext'
import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { ListStoreApiInput } from '@amzn/coral_com-amazon-jwostoremanagementgateway/ListStoreApiInput'
import { validateRequired } from './listenerUtils'

export async function getUserAndStoreContextListener (message: any): Promise<IUserAndStoreContext> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    return getUserAndStoreContext(params.storeId)
}

export async function getUserAliasListener (_message: any): Promise<string> {
    return getUserAlias()
}

export async function getStoreInformationListener (message: any): Promise<GetStoreApiOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    return getStoreInformation(params.storeId)
}

export async function getUserStoresListener (message: any): Promise<any> {
    const params = (message && message.data) || {}
    validateRequired(params, 'userAlias')
    const client = getServiceClient()
    return client.listStoreApi(
        ListStoreApiInput.clone({ maxResults: params.maxResults, nextToken: params.nextToken }),
    ).toPromise()
}

export async function getUserMerchantsListener (message: any): Promise<IGetUserMerchantsResult> {
    const params = (message && message.data) || {}
    validateRequired(params, 'userAlias')
    return getUserMerchants(params.userAlias)
}
